import React from 'react';

// ============================================================================
// Formato de dinheiro do Troco — padrão brasileiro + negativo em vermelho
// ============================================================================
// O saldo de numerário de uma loja PODE ficar negativo (a loja depositou no
// cofre mais do que recebeu de troco — sobra de caixa indo pro banco). Isso não
// é erro, mas precisa saltar aos olhos: negativo sai em VERMELHO e COM SINAL.
// Fonte única do formato para todas as telas do Troco.

// R$ 1.234,56 (pt-BR: ponto no milhar, vírgula no decimal).
const numero = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Sinal FORA do "R$" ("- R$ 120,00") — lê melhor que "R$ -120,00".
export const brl = (v) => {
    const n = parseFloat(v || 0);
    const texto = `R$ ${numero.format(Math.abs(n))}`;
    return n < 0 ? `- ${texto}` : texto;
};

export const VERMELHO = '#dc2626';

// Verde escuro das ações de CONFIRMAR do Troco (padronizado em 2026-07-30).
// Antes cada tela escolhia o seu: o Controle usava o teal do módulo, a
// Conferência misturava teal e verde-600 em dois botões com o MESMO rótulo.
//
// É o mesmo `#15803d` do badge "Recebimento do Escritório" (trocoStatus.js) — e
// isso é de propósito: o botão tem a cor do estado que ele produz, então a
// pessoa liga uma coisa à outra sem precisar ler. Fica valendo a leitura:
// teal = ação do módulo · VERDE = confirmar · vermelho = desfazer/excluir.
export const VERDE = '#15803d';

// Verde claro do botão desabilitado enquanto salva (mesma família do VERDE).
export const VERDE_CLARO = '#86efac';

/**
 * Valor monetário do Troco. Fica vermelho sozinho quando é negativo; nos demais
 * casos usa a cor que a tela pediu (`cor`).
 * `sinalPositivo` mostra o "+" nos valores de entrada (cards de Recebidos).
 */
export const Moeda = ({ valor, cor = '#0f172a', sinalPositivo = false, style }) => {
    const n = parseFloat(valor || 0);
    const prefixo = sinalPositivo && n > 0 ? '+ ' : '';
    return (
        <span style={{ color: n < 0 ? VERMELHO : cor, fontVariantNumeric: 'tabular-nums', ...style }}>
            {prefixo}{brl(n)}
        </span>
    );
};
